import { ErrorBoundary as EB, ErrorBoundaryProps, FallbackProps } from "react-error-boundary";

type Props = Readonly<{
    children?: React.ReactNode | undefined;
    FallbackComponent?: React.ComponentType<FallbackProps> | undefined;
    onReset?: ErrorBoundaryProps["onReset"];
}>;
export function ErrorBoundary({ children, FallbackComponent, onReset }: Props) {
    return (
        <EB
            FallbackComponent={FallbackComponent ?? DefaultErrorFallback}
            onError={(error) => {
                console.error(error);
                window.SoftrPageRenderer?.monitoring?.captureException?.(error);
            }}
            onReset={onReset}
        >
            {children}
        </EB>
    );
}

function DefaultErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
    // @ts-expect-error: Suppressed automatically in TS 5.8 to 6 migration
    if (process.env.NODE_ENV !== "production") {
        const message = error.message ? error.message : typeof error === "string" ? error : "Unknown error";
        const stack = error.stack ? error.stack : "No stack trace available";
        return (
            <div role="alert" style={{ padding: "0.75em 1em", marginTop: "2em" }}>
                <h2 style={{ textAlign: "center" }}>❗Something went wrong.</h2>
                <p style={{ textAlign: "center" }}>{message}</p>
                <p>Note: This error only shows up in non production environments</p>
                <pre style={{ backgroundColor: "rgba(255, 0, 0, 0.1)", color: "red", padding: "0.75em 1em" }}>
                    {stack}
                </pre>
                <button onClick={resetErrorBoundary}>Retry</button>
            </div>
        );
    }
    return null;
}
